import React, { Component, Fragment } from 'react'
import { Svg, ga } from '../../application'
import styled from 'react-emotion'
import { colors } from '../../styles'

const Wrapper = styled('span')`
  svg {
    background: #fff linear-gradient(#fff, #f2f2f2);
    color: ${colors.tui_dark_blue};
    border: 0;
    padding: 10px;
    border-radius: 4px;
    cursor: pointer;
    position: absolute;
    bottom: 5px;
    right: 5px;
    z-index: 102;
    width: 40px;
    height: 40px;
  }
`

export default class EditButton extends Component {
  open = (e) => {
    const { context, onManageHotel } = this.props
    e.preventDefault()
    e.stopPropagation()
    ga.buttonClick(context + '-view-open-edit-collection')
    onManageHotel()
  }

  render() {
    return (
      <Fragment>
        <Wrapper onClick={this.open}>
          <Svg icon="pencil" />
        </Wrapper>
      </Fragment>
    )
  }
}

